import React from "react";
import './InputField.css';

const prefixNumber = (str) => {
    if (str === "7") {
        return "7 (";
    }
    if (str === "8") {
        return "8 (";
    }
    if (str === "9") {
        return "7 (9";
    }
        return "7 (";
};

function phoneMask(event)
{
    const value = event.target.value.replace(/\D+/g, "");
    const numberLength = 11;

    let result;
    if (event.target.value.includes("+8") || event.target.value[0] === "8") {
        result = "";
    } else {
        result = "+";
    }

    for (let i = 0; i < value.length && i < numberLength; i++) {
        switch (i) {
        case 0:
            result += prefixNumber(value[i]);
            continue;
        case 4:
            result += ") ";
            break;
        case 7:
            result += "-";
            break;
        case 9:
            result += "-";
            break;
        default:
            break;
        }
        result += value[i];
    }

    event.target.value = result;
}

export default function InputField({props})
{
    return (
        <input value={props.state} onChange={(e) => props.handler(e.target.value)} type={props.type} maxLength={props.type === 'text' ? '25' : ''} onFocus={props.type === 'tel' ? (e) => props.handler('+7 (') : undefined} onInput={props.type === 'tel' ? phoneMask : undefined} placeholder={props.placeholder} name={props.name} className={props.form ? 'form-input-int' : 'form-input'} required></input>
    )
}